/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Src_2_NameInputs */

const en_wb_support_src_2_name = /** @type {(inputs: Wb_Support_Src_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday availability`)
};

const lv_wb_support_src_2_name = /** @type {(inputs: Wb_Support_Src_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sestdienas pieejamība`)
};

/**
* | output |
* | --- |
* | "Saturday availability" |
*
* @param {Wb_Support_Src_2_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_src_2_name = /** @type {((inputs?: Wb_Support_Src_2_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Src_2_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_src_2_name(inputs)
	return en_wb_support_src_2_name(inputs)
});